import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { PasswordProperties, usePasswordProperties } from "./PasswordProperties";

import { DraftPasswordComponent } from "./DraftPasswordComponent";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { PasswordField } from "./PasswordField";
import { Registry } from "../../../../../base/register";
import { SimplePassword } from "./SimplePassword";

export const PasswordComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = usePasswordProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getPasswordNode = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <PasswordField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimplePassword
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getPasswordNode()}
    </InputLabel>
}

Registry.addControl({
    id: "3d0caecc-4f17-4061-bf12-8660621c8695",
    name: "Password",
    type: ControlType.Password,
    properties: PasswordProperties,
    component: PasswordComponent,
    draftComponent: DraftPasswordComponent
})
